import React from 'react';
import { View, Text, StyleSheet, Image, TouchableOpacity, Platform, Alert as rnAlert, Dimensions, Pressable } from 'react-native';
import CS from '../../constants/Styles';
import Colors from '../../constants/Colors';
import { TextInputContainer, Button, Validate, BackgroundGradient, OrSeparator, AppleAuthButton, FacebookAuthButton, GoogleAuthButton, Loader, MFAModal, Alert, PlayVideoButton } from '../../components';
import * as AppleAuthentication from 'expo-apple-authentication';
// import { api } from '../../constants/DevProd';
import * as rtApi from '../../components/Api';
import * as Application from 'expo-application';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
// import { useIsFocused } from '@react-navigation/native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useHeaderHeight } from '@react-navigation/elements';
import { FontAwesome5 } from '@expo/vector-icons';
import { useLinkTo } from '@react-navigation/native';

const EmailPassword = ({ navigation, route, ...props }) => {
  const defaultIsInvalid = { emailAddress: false, emailAddressConfirm: false, password: false, confirmPassword: false };
  const [isInvalid, setIsInvalid] = React.useState(defaultIsInvalid);
  const [loading, setLoading] = React.useState(false);
  const [alertOptions, setAlertOptions] = React.useState({});

  const [socialUser, setSocialUser] = React.useState(null);
  const [uniqueDevice, setUniqueDevice] = React.useState(null);
  const [showMFA, setShowMFA] = React.useState(false);
  const [MFACode, setMFACode] = React.useState(null);
  const [MFATrusted, setMFATrusted] = React.useState(true);
  const [MFARequired, setMFARequired] = React.useState(false);

  const [emailAddressConfirm, setEmailAddressConfirm] = React.useState('');
  const [passwordLength, setPasswordLength] = React.useState(0);
  const [passwordLengthValid, setPasswordLengthValid] = React.useState(false);
  const [passwordConfirmLength, setPasswordConfirmLength] = React.useState(0);
  const [passwordConfirmLengthValid, setPasswordConfirmLengthValid] = React.useState(false);
  const [logoWebStyle, setLogoWebStyle] = React.useState({});

  const headerHeight = useHeaderHeight();
  const linkTo = useLinkTo();
  const windowWidth = Dimensions.get('window').width;
  const insets = useSafeAreaInsets();

  let textInputs = {
    emailAddress: React.useRef(null),
    emailAddressConfirm: React.useRef(null),
    password: React.useRef(null),
    confirmPassword: React.useRef(null),
  };

  React.useEffect(() => {
    getUniqueDevice();
    setLogoWebStyle(logoStyle(windowWidth));
    return () => rtApi.cancel();
  }, []);
  React.useEffect(() => {
    checkMFACode();
  }, [MFACode]);
  React.useEffect(() => {
    if (Platform.OS === 'web') {
      const subscription = Dimensions.addEventListener('change', onChangeDimensions);
      return () => {
        subscription.remove();
        // Dimensions.removeEventListener('change', onChangeDimensions);
      }
    }
  }, []);

  const onChangeDimensions = ({ window, screen }) => {
    console.log('onChangeDimensions');
    setLogoWebStyle(logoStyle(window.width));
  };

  const getUniqueDevice = async () => {
    console.log('getUniqueDevice');
    if (Platform.OS === 'ios') {
      setUniqueDevice(await Application.getIosIdForVendorAsync());
    } else if (Platform.OS === 'android') {
      setUniqueDevice(Application.androidId);
    }
  }
  const checkMFACode = () => {
    console.log('MFACode', MFACode);
    if (String(MFACode).length === 6) {
      setShowMFA(false);
      if (MFARequired) {
        socialApiLoginWrapper();
      }

    }
  }
  const buildSocialFormData = (user, type) => {
    console.log('buildSocialFormData', user, type);
    let fd = new FormData();
    fd.append('user_id', user.id);
    fd.append('access_token', user.token);
    fd.append('unique_device', uniqueDevice);
    // if (longitude) {
    //   fd.append('longitude', longitude);
    // }
    // if (latitude) {
    //   fd.append('latitude', latitude);
    // }
    if (MFARequired && MFACode) {
      fd.append('MFA', MFACode);
      fd.append('trusted', MFATrusted ? 1 : 0);
    }
    if (type === 'google') {
      fd.append('id_token', user.idToken);
    }
    console.log('buildSocialFormData end');
    return fd;
  }
  const socialApiLogin = async (user, type) => {
    console.log('socialApiLogin', user, type);
    setLoading(true);
    return new Promise((resolve, reject) => {
      const fd = buildSocialFormData(user, type);
      console.log('built fd');
      rtApi.post('login', fd)
      .then(data => {
        console.log('socialApiLogin data', data);
        resolve(data);
      }).catch(err => {
        setAlertOptions({ visible: true, title: 'Error', message: 'Something went wrong. Please try again later.', });
        reject(err);
      }).finally(() => {
        setLoading(false);
      });
    });
  }
  const socialApiLoginWrapper = async () => {
    let sr = await socialApiLogin(socialUser, loginType.toLowerCase());
    if (sr.result) {
      checkUsernameSecureStore(sr.session.account);
    } else {
      setAlertOptions({ visible: true, title: 'Error', message: 'Invalid Code', });
      setMFACode(null);
      showMFA(true);
    }
  }

  const checkEmailPassword = async () => {
    // emailAddress
    if (!Validate.Email(props.emailAddress)) {
      setIsInvalid(prevState => { return { ...prevState, emailAddress: true } });
      textInputs.emailAddress.current.focus();
      return;
    }
    setIsInvalid(prevState => { return { ...prevState, emailAddress: false } });
    // emailAddressConfirm
    if (!Validate.Email(emailAddressConfirm)) {
      setIsInvalid(prevState => { return { ...prevState, emailAddressConfirm: true } });
      textInputs.emailAddressConfirm.current.focus();
      return;
    }
    setIsInvalid(prevState => { return { ...prevState, emailAddressConfirm: false } });
    // emails match
    if (props.emailAddress !== emailAddressConfirm) {
      setIsInvalid(prevState => { return { ...prevState, emailAddress: true, emailAddressConfirm: true } });
      setAlertOptions({ visible: true, title: 'Invalid', message: 'Email Addresses must match.', });
      return;
    }
    // password
    if(props.accountType === 'Email'){
      console.log('props.password', props.password);
      if (!Validate.Password(props.password)) {
        setIsInvalid(prevState => { return { ...prevState, password: true } });
        textInputs.password.current.focus();
        setAlertOptions({ visible: true, title: 'Invalid', message: 'Please enter a password that is at least 15 characters long.', });
        return;
      }
      setIsInvalid(prevState => { return { ...prevState, password: false } });
      // confirmPassword
      if (!Validate.Password(props.confirmPassword)) {
        setIsInvalid(prevState => { return { ...prevState, confirmPassword: true } });
        textInputs.confirmPassword.current.focus();
        setAlertOptions({ visible: true, title: 'Invalid', message: 'Please enter a password that is at least 15 characters long.', });
        return;
      }
      setIsInvalid(prevState => { return { ...prevState, confirmPassword: false } });
      // do passwords match
      if(props.password !== props.confirmPassword){
        setIsInvalid(prevState => { return { ...prevState, password: true, confirmPassword: true } });
        setAlertOptions({ visible: true, title: 'Invalid', message: 'Passwords must match.', });
        return;
      }
    } // passwords check

    setLoading(true);
    let existingResult = await Validate.isExistingEmail(props.emailAddress);
    setLoading(false);
    console.log('existingResult', existingResult);
    if (existingResult.result){
      if(existingResult.isExisting){
        console.log('alert...');
        setAlertOptions({
          visible: true,
          title: 'Existing Email Address',
          message: 'This email address has already been used to create an account.',
          buttons: [
            {
              text: 'Login with this email address',
              // onPress: () => navigation.navigate('Login', { emailAddress: props.emailAddress }),
              onPress: () => linkTo(`/login?emailAddress=${props.emailAddress}`),
            },
            {
              text: 'Edit email address',
              onPress: () => editEmailAddress(),
            }
          ]
        });
        return;
      }
    }else{
      return;
      // setAlertOptions({ visible: true, title: 'Error', message: existingResult.error, });
    }
    props.completeStep('EmailPassword');
  };

  const editEmailAddress = () => {
    props.setEmailAddress('');
    setEmailAddressConfirm('');
    textInputs.emailAddress.current.focus();
  }

  const onChangeEmailAddress = (emailAddress) => {
    if(isInvalid.emailAddress && Validate.Email(emailAddress)){
      setIsInvalid(prevState => { return { ...prevState, emailAddress: false } });
    }
    props.setEmailAddress(emailAddress.trim());
    props.setContractorEmailAddress(emailAddress.trim());
  };
  const onChangePassword = (password) => {
    if (isInvalid.password && Validate.Password(password)) {
      setIsInvalid(prevState => { return { ...prevState, password: false } });
    }
    props.setPassword(password);
    setPasswordLength(password.length);
    setPasswordLengthValid(password.length >= 15 ? true : false);
  };
  const onChangeConfirmPassword = (confirmPassword) => {
    if (isInvalid.confirmPassword && Validate.Password(confirmPassword)) {
      setIsInvalid(prevState => { return { ...prevState, confirmPassword: false } });
    }
    props.setConfirmPassword(confirmPassword);
    setPasswordConfirmLength(confirmPassword.length);
    setPasswordConfirmLengthValid(confirmPassword.length >= 15 ? true : false);
  };

  const cancelMFA = () => {
    setShowMFA(false);
    setMFACode(null);
    setMFARequired(false);
  }

  const logoStyle = (windowWidth) => {
    if (Platform.OS === 'web') {
      const ratio = 344 / 936;
      let width = (windowWidth >= 768 ? 768 : windowWidth) * .80;
      if (width > 450) { width = 450; }
      return {
        width: width,
        height: width * ratio,
      }
    }
    return {};
  }

  const goBack = () => {
    linkTo('/login');
  }

  return (
    <View style={CS.container}>
      <BackgroundGradient />
      <Loader animating={loading} />
      <MFAModal
        show={showMFA}
        cancel={cancelMFA}
        setMFACode={setMFACode}
        setMFATrusted={setMFATrusted}
        showTrusted={false}
        MFATrusted={MFATrusted}
      />
      <Alert options={alertOptions} setOptions={setAlertOptions} />
      <KeyboardAwareScrollView extraHeight={headerHeight + 20} keyboardShouldPersistTaps='handled' contentContainerStyle={[styles.innerContainer, { paddingTop: insets.top, paddingBottom: insets.bottom }]}>
        <Pressable hitSlop={10} onPress={goBack} style={({ pressed }) => [{ opacity: pressed ? 0.5 : 1.0, position:'absolute', top: insets.top || 10, left:0, marginVertical: 0 }]}>
          <FontAwesome5 name="arrow-left" size={24} color="white" />
        </Pressable>
        <View style={styles.logoTextContainer}>
          <Image source={require('../../assets/img/logo_border_text_white.png')} style={[CS.responsiveImage, styles.logoTextImage, logoWebStyle]} />
        </View>
        <PlayVideoButton 
          text='How to create an account'
          length='1:26'
          source='https://renovationtrust.s3.ca-central-1.amazonaws.com/production/resources/accountCreationTutorial.mp4'
          youtube='TtGaexIG44o'
          outerContainerStyle={styles.playVideoContainer}
        />
        {(props.accountType === 'Email' && Platform.OS === 'ios' && AppleAuthentication.isAvailableAsync()) && (
          <View style={styles.providerButton}>
            <AppleAuthButton
              setLoading={setLoading}
              navigation={navigation}
              setShowMFA={setShowMFA}
              setMFARequired={setMFARequired}
              // setLoginType={setLoginType}
              socialApiLogin={socialApiLogin}
              setSocialUser={setSocialUser}
            />
          </View>
        )}

        {props.accountType === 'Email' 
        ?
         <>
            <View style={styles.providerButton}>
              <FacebookAuthButton
                setLoading={setLoading}
                navigation={navigation}
                setShowMFA={setShowMFA}
                setMFARequired={setMFARequired}
                // setLoginType={setLoginType}
                socialApiLogin={socialApiLogin}
                setSocialUser={setSocialUser}
              />
            </View>
            <View style={styles.providerButton}>
              <GoogleAuthButton
                setLoading={setLoading}
                navigation={navigation}
                setShowMFA={setShowMFA}
                setMFARequired={setMFARequired}
                // setLoginType={setLoginType}
                socialApiLogin={socialApiLogin}
                setSocialUser={setSocialUser}
              />
            </View>
            <OrSeparator />
         </>
        : null 
        }

        {props.accountType === 'Email' ?
          <Text style={[CS.mediumText, CS.lightText, styles.signUpEmailText]}>Sign up with your email address</Text>
          :
          <Text style={[CS.mediumText, CS.lightText, styles.signUpEmailText]}>To sign up with your <Text style={CS.yellowText}>{props.accountType}</Text> account you must confirm your email address</Text>
        }
        
        <TextInputContainer 
          iconName='envelope' 
          placeholder='Email Address' 
          textContentType='emailAddress' 
          onChangeText={(t) => onChangeEmailAddress(t)} 
          inputRef={textInputs.emailAddress}
          keyboardType='email-address'
          // autoFocus={true} 
          isInvalid={isInvalid.emailAddress}
          value={props.emailAddress}
          autoCapitalize='none'
          autocompleteType='email'
          autoCorrect={false}
          // clear-button-mode='while-editing'
          returnKeyType='next'
          enablesReturnKeyAutomatically={true}
          onSubmitEditing={() => textInputs.emailAddressConfirm.current.focus()}
        />
        <TextInputContainer
          iconName='envelope'
          placeholder='Re-Type Email Address'
          textContentType='emailAddress'
          onChangeText={(t) => setEmailAddressConfirm(t)}
          inputRef={textInputs.emailAddressConfirm}
          keyboardType='email-address'
          // autoFocus={true} 
          isInvalid={isInvalid.emailAddressConfirm}
          value={emailAddressConfirm}
          autoCapitalize='none'
          autocompleteType='email'
          autoCorrect={false}
          // clear-button-mode='while-editing'
          returnKeyType='next'
          enablesReturnKeyAutomatically={true}
          onSubmitEditing={() => textInputs.password.current.focus()}
        />
        {props.accountType === 'Email'
        ?
          <>
            <View style={CS.passwordInputContainer}>
              <TextInputContainer
                iconName='lock'
                placeholder='Choose Password'
                // textContentType='newPassword'
                textContentType='none'
                secureTextEntry={true}
                onChangeText={(t) => onChangePassword(t)}
                inputRef={textInputs.password}
                isInvalid={isInvalid.password}
                autoCapitalize='none'
                enablesReturnKeyAutomatically={true}
                autoCorrect={false}
                inputContainerStyle={{ marginBottom: 0, width: '100%' }}
                returnKeyType='next'
                onSubmitEditing={() => textInputs.confirmPassword.current.focus()}
                // passwordRules="required: lower; required: upper; required: digit; required: [-]; minlength: 15;"
              />
              <View style={styles.characterCount}>
                <Text style={[CS.miniText, CS.redText, (passwordLengthValid && styles.validText)]}>{passwordLength}</Text>
              </View>
            </View>
            <View style={CS.passwordInputContainer}>
              <TextInputContainer
                iconName='lock'
                placeholder='Re-type Password'
                // textContentType='newPassword'
                textContentType='none'
                secureTextEntry={true}
                onChangeText={t => onChangeConfirmPassword(t)}
                inputRef={textInputs.confirmPassword}
                isInvalid={isInvalid.confirmPassword}
                autoCapitalize='none'
                enablesReturnKeyAutomatically={true}
                autoCorrect={false}
                inputContainerStyle={{ marginBottom: 0, width: '100%' }}
                returnKeyType='done'
                onSubmitEditing={checkEmailPassword}
                // passwordRules="required: lower; required: upper; required: digit; required: [-]; minlength: 15;"
              />
              <View style={styles.characterCount}>
                <Text style={[CS.miniText, CS.redText, (passwordConfirmLengthValid && styles.validText)]}>{passwordConfirmLength}</Text>
              </View>
            </View>
            <Text style={[CS.greyText, CS.smallText, styles.passwordText]}>Your password must be a minimum of 15 characters. We recommend a series of 4 words that will be easier to remember and harder for hackers.</Text>
          </>
        : null}
        
        <Button text='Continue' onPress={() => checkEmailPassword} />
      </KeyboardAwareScrollView>
    </View>
  )
}

const styles = StyleSheet.create({
  innerContainer: {
    // backgroundColor: 'pink',
    maxWidth: Platform.OS === 'web' ? 768 : '100%',
    justifyContent: 'center',
    flexGrow: 1,
    width: '100%',
  },
  logoTextContainer: {
    width: '80%',
    alignSelf: 'center',
    alignItems: 'center',
    // backgroundColor: 'red',
    marginBottom: 30,
  },
  logoTextImage: {
    aspectRatio: 936 / 344,
  },
  passwordText: {
    marginBottom: 20,
  },
  providerButton: {
    marginBottom: 10,
  },
  signUpEmailText: {
    marginBottom: 20,
  },
  characterCount: {
    position: 'absolute',
    top: 0,
    right: 0,
    color: Colors.red,
    padding: 10,
    // width: 20,
    // backgroundColor: Colors.textInputBackground,
    backgroundColor: 'transparent',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  validText: {
    color: Colors.green,
  },
  playVideoContainer: {
    // width: '100%',
    // height: 20,
    alignSelf: 'stretch',
    // height: 54,
    // backgroundColor: 'pink',
    marginBottom: 20,
    ...Platform.select({
      web: {
        width: '100%',
        maxWidth: 450,
        alignSelf: 'center',
        height: 'auto',
      }
    })
  },
});

export default React.memo(EmailPassword);